import { create } from 'zustand'

import type { TClientProfile } from '../types/client-profile.type'

export type CustomerProfileStoreState = {
  dataProfile: TClientProfile | undefined
}

export type CustomerProfileStoreAction = {
  actions: {
    setDataProfile: (props: TClientProfile | undefined) => void
  }
}

export const useCustomerProfileStore = create<
  CustomerProfileStoreState & CustomerProfileStoreAction
>((set) => ({
  dataProfile: undefined,
  actions: {
    setDataProfile: (props) => set({ dataProfile: props }),
  },
}))
